import { EMP_LIST, BULK_APPROVE_TASK } from "./ActionType";

const initialValue = {
    emplists: [],
    bulkapprove: [],
}

export const dailyUpdateApprovalReducer = (store = initialValue, { type, payload }) => {

    if (type === EMP_LIST) {
        return {
            ...store, emplists: payload.userList || [],
        };
    } else if (type === BULK_APPROVE_TASK) {
        return {
            ...store, bulkapprove: payload.userList || [],
        };
    }

    return store
}